import React from "react";

// Components
import Upload from "../toolbox/Upload";
import UploadLogo from "../toolbox/UploadLogo";
import CustomText from "../toolbox/InputText";
import CustomTextNumber from "../toolbox/inputTextNumber";
const Inputs = ({
  checked,
  setchecked,
  checkedGuild,
  setcheckedGuild,
  handleChange,
  handleChangeGuild,
  uploadedImage,
  setUploadedImage,
  uploadedLogoImage,
  setUploadedLogoImage,
  userName,
  setUsername,
  guildName,
  setGuildname,
  fontFamily,
  setFontFamily,
  bgColor,
  setBgColor,
  fontColor,
  setFontColor,
  alignment,
  bgColorGuild,
  setBgColorGuild,
  fontColorGuild,
  setFontColorGuild,
  handleAlignment,
  fontFamilyGuild,
  setFontFamilyGuild,
  align,
  setHeight,
  setWidth,
  contactNumber,
  setContactNumber,
  guildSeconedName,
  setGuildSeconedName,
  birthdayWish,
  setBirthdayWish,
}) => (
  <div>
    <Upload
      uploadedImage={uploadedImage}
      setUploadedImage={setUploadedImage}
      uploadedLogoImage={uploadedLogoImage}
      setUploadedLogoImage={setUploadedLogoImage}
      setHeight={setHeight}
      setWidth={setWidth}
    />
    {/* <UploadLogo
      setUploadedLogoImage={setUploadedLogoImage}
      uploadedImage={uploadedImage}
      setUploadedImage={setUploadedImage}
      uploadedImage={uploadedLogoImage}
      setHeight={setHeight}
      setWidth={setWidth}
    /> */}
    {/* <CustomText
      label="Name"
      placeholder="Your Name"
      checked={checked}
      checkedGuild={checkedGuild}
      setchecked={setchecked}
      setcheckedGuild={setcheckedGuild}
      handleChange={handleChange}
      handleChangeGuild={handleChangeGuild}
      userName={userName}
      setUsername={setUsername}
      guildName={guildName}
      setGuildname={setGuildname}
      fontFamily={fontFamily}
      setFontFamily={setFontFamily}
      bgColor={bgColor}
      setBgColor={setBgColor}
      fontColor={fontColor}
      setFontColor={setFontColor}
      alignment={alignment}
      bgColorGuild={bgColorGuild}
      setBgColorGuild={setBgColorGuild}
      fontColorGuild={fontColorGuild}
      setFontColorGuild={setFontColorGuild}
      fontFamilyGuild={fontFamilyGuild}
      setFontFamilyGuild={setFontFamilyGuild}
      handleAlignment={handleAlignment}
      align={align}
      onChange={(e) => {
        if (e.target.value.length <= 21) {
          setUsername(e.target.value);
        }
      }}
      value={userName}
    />
    <CustomText
      placeholder="Your Company Name"
      label="Company Name"
      checked={checked}
      checkedGuild={checkedGuild}
      setchecked={setchecked}
      setcheckedGuild={setcheckedGuild}
      handleChange={handleChange}
      handleChangeGuild={handleChangeGuild}
      userName={userName}
      setUsername={setUsername}
      guildName={guildName}
      setGuildname={setGuildname}
      fontFamily={fontFamily}
      setFontFamily={setFontFamily}
      bgColor={bgColor}
      setBgColor={setBgColor}
      fontColor={fontColor}
      setFontColor={setFontColor}
      alignment={alignment}
      bgColorGuild={bgColorGuild}
      setBgColorGuild={setBgColorGuild}
      fontColorGuild={fontColorGuild}
      setFontColorGuild={setFontColorGuild}
      fontFamilyGuild={fontFamilyGuild}
      setFontFamilyGuild={setFontFamilyGuild}
      handleAlignment={handleAlignment}
      align={align}
      onChange={(e) => {
        if (e.target.value.length <= 18) {
          setGuildname(e.target.value);
        }
      }}
      value={guildName}
    /> */}
    <CustomText
      placeholder="Your Name"
      label="Your Name*"
      checked={checked}
      checkedGuild={checkedGuild}
      setchecked={setchecked}
      setcheckedGuild={setcheckedGuild}
      handleChange={handleChange}
      handleChangeGuild={handleChangeGuild}
      userName={userName}
      setUsername={setUsername}
      guildName={guildName}
      setGuildname={setGuildname}
      fontFamily={fontFamily}
      setFontFamily={setFontFamily}
      bgColor={bgColor}
      setBgColor={setBgColor}
      fontColor={fontColor}
      setFontColor={setFontColor}
      alignment={alignment}
      bgColorGuild={bgColorGuild}
      setBgColorGuild={setBgColorGuild}
      fontColorGuild={fontColorGuild}
      setFontColorGuild={setFontColorGuild}
      fontFamilyGuild={fontFamilyGuild}
      setFontFamilyGuild={setFontFamilyGuild}
      handleAlignment={handleAlignment}
      align={align}
      onChange={(e) => {
        if (e.target.value.length <= 18) {
          setGuildSeconedName(e.target.value);
        }
      }}
      value={guildSeconedName}
    />
    <CustomText
      placeholder="Birthday Wish Message"
      label="Birthday Wish*"
      checked={checked}
      checkedGuild={checkedGuild}
      setchecked={setchecked}
      setcheckedGuild={setcheckedGuild}
      handleChange={handleChange}
      handleChangeGuild={handleChangeGuild}
      userName={userName}
      setUsername={setUsername}
      guildName={guildName}
      setGuildname={setGuildname}
      fontFamily={fontFamily}
      setFontFamily={setFontFamily}
      bgColor={bgColor}
      setBgColor={setBgColor}
      fontColor={fontColor}
      setFontColor={setFontColor}
      alignment={alignment}
      bgColorGuild={bgColorGuild}
      setBgColorGuild={setBgColorGuild}
      fontColorGuild={fontColorGuild}
      setFontColorGuild={setFontColorGuild}
      fontFamilyGuild={fontFamilyGuild}
      setFontFamilyGuild={setFontFamilyGuild}
      handleAlignment={handleAlignment}
      align={align}
      onChange={(e) => {
        if (e.target.value.length <= 400) {
          setBirthdayWish(e.target.value);
        }
      }}
      value={birthdayWish}
    />
     {/* <CustomText
      placeholder="Enter Phone Number"
      label="Phone Number*"
      checked={true}
      checkedGuild={false}
      setchecked={() => {}}
      setcheckedGuild={() => {}}
      handleChange={() => {}}
      handleChangeGuild={() => {}}
      userName={contactNumber}
      setUsername={setContactNumber}
      guildName={guildName}
      setGuildname={setGuildname}
      fontFamily={fontFamily}
      setFontFamily={setFontFamily}
      bgColor={bgColor}
      setBgColor={setBgColor}
      fontColor={fontColor}
      setFontColor={setFontColor}
      alignment={alignment}
      bgColorGuild={bgColorGuild}
      setBgColorGuild={setBgColorGuild}
      fontColorGuild={fontColorGuild}
      setFontColorGuild={setFontColorGuild}
      fontFamilyGuild={fontFamilyGuild}
      setFontFamilyGuild={setFontFamilyGuild}
      handleAlignment={handleAlignment}
      align={align}
      onChange={(e) => {
        const digitsOnly = e.target.value.replace(/\D/g, "");
        if (digitsOnly.length <= 10) {
          setContactNumber(digitsOnly);
        }
      }}
      value={contactNumber}
    /> */}
  </div>
);

export default Inputs;
